import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { ArrowRight } from "lucide-react";
import { useSiteContent } from "@/hooks/useSiteContent";
import { DEFAULTS } from "@/lib/content_defaults";

export default function Programs() {
  const [programs, setPrograms] = useState([]);
  const { data: hero } = useSiteContent("page_hero_programs", DEFAULTS.page_hero_programs);
  useEffect(() => { api.get("/programs").then((r) => setPrograms(r.data)); }, []);

  return (
    <div>
      <section className="section-dark py-24">
        <div className="container-app">
          <div className="label-tag mb-4">{hero.label_tag}</div>
          <h1 className="font-heading font-black uppercase text-5xl md:text-7xl leading-none">
            {hero.line1}<br/><span className="metallic-gold">{hero.line2}</span><br/><span className="metallic-silver">{hero.line3}</span>
          </h1>
          <p className="mt-8 text-white/70 max-w-2xl text-lg">{hero.subtitle}</p>
        </div>
      </section>
      <section className="section-light py-16">
        <div className="container-app grid md:grid-cols-2 gap-6" data-testid="programs-grid">
          {programs.map((p, i) => (
            <div key={p.key} className={`card-light hover-lift overflow-hidden ${i % 3 === 0 ? "md:col-span-2" : ""}`} data-testid={`program-item-${p.key}`}>
              <div className={`grid ${i % 3 === 0 ? "md:grid-cols-2" : ""}`}>
                <div className={`aspect-[16/10] ${i % 3 === 0 ? "md:aspect-auto" : ""} overflow-hidden bg-black`}>
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover" />
                </div>
                <div className="p-8">
                  <div className="label-tag mb-2" style={{ color: "#000" }}>{p.tagline}</div>
                  <div className="font-heading font-black uppercase text-3xl md:text-4xl">{p.title}</div>
                  <p className="mt-4 text-neutral-700 leading-relaxed">{p.description}</p>
                  <div className="mt-6 flex gap-3">
                    <Link to="/register" className="btn-gold" data-testid={`program-cta-${p.key}`}>Enroll <ArrowRight size={16} /></Link>
                    <Link to="/pricing" className="btn-ghost-dark">Pricing</Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
